<template>
<div :style="{ backgroundColor: backgroundcolor }" id="wrapper">

    <div class="baselogin">
       <div id="logo_chat_nuevo">
          <img src="https://imagenes.leon.gob.mx/logo-leon-bco.svg" width="150px" >
      </div>
      <div id="logo_chat_psico">
          <img src="img/logoatencion.png" width="90px" >
      </div>
      <form class="form-signin" @submit.prevent="checkForm">
        <div class="input-group" v-if="status">
          <div class="input-group-prepend">
            <span class="input-group-text bg-white border-right-0">
              <i class="fa fa-user" style="color:#2C4DB8;"></i>
            </span>
          </div>
          <input
            type="text"
            v-if="status"
            v-model="name"
            maxlength="20"
            class="form-control border-left-0"
            placeholder="Nombre"
            required
          >
        </div>
        
        <div class="input-group" v-if="status">
          <div class="input-group-prepend">
            <span class="input-group-text bg-white border-right-0">
              <i class="fa fa-envelope" style="color:#2C4DB8;"></i>
            </span>
          </div>
          <input
            type="email"
            v-if="status"
            v-model="email"
            maxlength="30"
            class="form-control border-left-0"
            placeholder="Correo electrónico"
            required
            autofocus
          >
        </div>
        
        <div id="aviso-privacidad" v-if="status">
          <label >
            <input type="checkbox" required> 
              &nbsp;He leído el 
              <a 
              href="https://www.leon.gob.mx/avisos-privacidad/aviso-atencion-piscologica-en-linea.pdf"
              target="_blank"
              >Aviso de Privacidad.</a>
          </label>
        </div>

        <button
          v-if="status"
          class="btn "
          style="background-color:#ff9c00;color: #fff; margin-top: 10px"
        >Iniciar chat</button>
      </form>
      <br>
      <div class="alert alert-danger" v-if="mensaje">{{mensaje}}</div>
      <span class="horarios">
        <strong>Horarios de atención</strong>
        <br>Lunes a Domingo de 8:00 am a 8:00 pm
      </span>
    </div>
</div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Login",
  props: {
    msg: String
  },
  data() {
    return {
      name: null,
      email: null,
      mensaje: null,
      status: null,
      ipAddress : null,
      bloqueado:false,
      listOfIp:[],
       backgroundcolor: "#EEEEED",
    };
  },
  methods: {
    getList(){
      return firebase.database().ref("/blacklist").once("value")
    },
    updateMensaje(mensaje) {
      this.mensaje = mensaje;
    },
    checkForm() {
      if(!this.bloqueado){
        this.$router.push({
          name: "Sala",
          params: {
            name: this.name,
            email: this.email,
            ipAddress: this.ipAddress
          }
        });
      }
      else{
        this.updateMensaje("Se ha detectado mal uso de ésta herramientas desde éste equipo, se ha bloqueado temporalmente.")
      }
    },
    async getIp() {
      return new Promise(function(resolve, reject) {
        var RTCPeerConnection =
          /*window.RTCPeerConnection ||*/ window.webkitRTCPeerConnection ||
          window.mozRTCPeerConnection;

        if (!RTCPeerConnection) {
          reject("Your browser does not support this API");
        }

        var rtc = new RTCPeerConnection({ iceServers: [] });
        var addrs = {};
        addrs["0.0.0.0"] = false;

        function grepSDP(sdp) {
          //var hosts = [];
          var finalIP = "";
          sdp.split("\r\n").forEach(function(line) {
            if (~line.indexOf("a=candidate")) {
              let parts = line.split(" "), // http://tools.ietf.org/html/rfc5245#section-15.1
                addr = parts[4],
                type = parts[7];
              if (type === "host") {
                finalIP = addr;
              }
            } else if (~line.indexOf("c=")) {
              let parts = line.split(" "),
                addr = parts[2];
              finalIP = addr;
            }
          });
          return finalIP;
        }

        if (1 || window.mozRTCPeerConnection) {
          rtc.createDataChannel("", { reliable: false });
        }

        rtc.onicecandidate = function(evt) {
          if (evt.candidate) {
            var addr = grepSDP("a=" + evt.candidate.candidate);
            resolve(addr);
          }
        };
        rtc.createOffer(
          function(offerDesc) {
            rtc.setLocalDescription(offerDesc);
          },
          function(e) {
            console.warn("offer failed", e);
          }
        );
      });
    }
  },
  created() {
    var self = this;
    this.mensaje = "";
    this.status = 0;
    this.ipAddress = ""
    this.getIp().then((ipAdd)=>{
      this.getList().then((ipList)=>{
        ipList.forEach((ip)=>{
         if((ip.val().ip === ipAdd)){
           self.bloqueado = true
         }
        })
      })
      self.ipAddress = ipAdd
    });
    firebase
      .database()
      .ref("/users/online")
      .once("value")
      .then(function(snap) {
          let onLineOperators = snap
          let operatorsList= []
          onLineOperators.forEach((e)=>{
           operatorsList.push(e.val())
          })
          let isOnLine = operatorsList.filter((e)=>{
            return e.loggIn==true
          })
          if (isOnLine.length >= 1) {
            self.updateMensaje("");
            self.status = 1;
            let activeSession = localStorage.sesionID;
            if (activeSession != null || activeSession != undefined) {
              firebase
                .database()
                .ref(`/lobby/users/${activeSession}`)
                .once("value")
                .then(function(snap) {
                  if (snap.val() != null) {
                    if (snap.val().status == 0) {
                      localStorage.removeItem("sesionID");
                      firebase
                        .database()
                        .ref(`lobby/users/${activeSession}`)
                        .remove();
                    } else if (
                      snap.val().status == 4 ||
                      snap.val().status == 3 ||
                      snap.val().status == 1
                    ) {
                      self.$router.push({
                        name: "Atencion",
                        ipAddress: self.ipAddress,
                        params: {
                          keyId: activeSession,
                          as: snap // OJO
                        }
                      });
                    } else {
                      localStorage.removeItem("sesionID");
                    }
                  } else {
                    localStorage.removeItem("sesionID");
                  }
                });
            }
          } else {
            self.updateMensaje("No hay operadores conectados");
            self.status = 0;
          }
        
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="@/assets/css/signin.css"/>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #wrapper{
    background-image: url("/img/fondo.jpeg");
    background-size: cover;
  }

  .baselogin{
    background-image: url("/img/baselogin.png");
    width: 400px;
    height: 550px;
    position: relative;
    left: calc(50% - 200px);
    top: 10px;
    /* border: 1px solid red; */
    background-size: cover;
  }

  #logo_chat_nuevo{
    /*padding: 50px 0;*/
    padding: 120px 0 40px 0;
  }
  #logo_chat_nuevo img{
    width: 30%;
  }
  .input-group{
    margin-bottom: 10px;
  }
  .input-group-prepend{
    height: 34px;
  }
  .input-group-text{
    border: none;
  }

  .input-group-text i{
    color: #103463 !important;
  }
  .input-group input{
     height: 34px !important;
     background-color: #a1c3e1;
     color: #fff;
  }

  .input-group input::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #fff;
    opacity: 1; /* Firefox */
  }

  .input-group input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #fff;
  }

  .input-group input::-ms-input-placeholder { /* Microsoft Edge */
    color: #fff;
  }

  input[type=checkbox] {
      vertical-align: middle;
      position: relative;
      bottom: 1px;
  }
          
  label {
      display: block;
  }

  #logo_chat_psico{
    /*padding: 20px 0;*/
    padding: 20px 0 0px 0;
  }

  #aviso-privacidad{
    /*padding: 20px 0;*/
    padding: 10px 0;
    color: #fff;
  }

</style>